<template lang="html">

  <b-modal ref="privacypolicy" size="lg" no-close-on-esc no-close-on-backdrop hide-header-close title="StrinGnosis® Online Privacy Notice">
    <div class="modal-scroll-container">
      <div>
        <textarea rows="5" class="w-100" readonly>We collect and store the data you enter on this form in order to provide you with our services and to contact you. We do not share it with anyone else, and we delete it when the relationship terminates.</textarea>
        <form @submit.stop.prevent="handleSubmit"></form>
      </div>
    </div>
    
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="btn btn-lg btn-blade btn-block" @click="close()">OK</b-btn>
    </div>

  </b-modal>

</template>

<script lang="js">
export default {
  name: 'privacy-policy',
  props: [],
  mounted () {
    var self = this
    self.$eventBus.$on('show-privacy-policy', () => {
      self.$refs.privacypolicy.show()
    })
  },
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
    close () {
      this.$refs.privacypolicy.hide()
    }
  }
}
</script>

<style scoped lang="scss">
textarea {
    resize: none;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue